import {createAsyncThunk} from '@reduxjs/toolkit';

import fetchRequest, {fetchDownloadRequest} from './utils';
import omitEmpty from '../utils/omitEmpty';

export const getInsightsReports = createAsyncThunk(
    'insightsReports/getInsightsReports',
    async (params) => {
        const {view, ...restParams} = params;
        return fetchRequest('/insights/reports', 'GET', restParams);
    }
);

export const getInsightsReportById = createAsyncThunk(
    'insightsReports/getInsightsReportById',
    async (id) => fetchRequest(`/insights/reports/${id}`, 'GET')
);

export const updateInsightsReportById = createAsyncThunk(
    'insightsReports/updateInsightsReportById',
    async ({reportId, statusId}) => fetchRequest(`/insights/reports/${reportId}`, 'PATCH', null, {statusId})
);

export const bulkUpdateInsightsReports = createAsyncThunk(
    'insightsReports/bulkUpdateInsightsReports',
    async ({reportIds, statusId, getReportsParams}, thunkAPI) => {
        const params = {reportIds, statusId};
        await fetchRequest('/insights/reports', 'PUT', null, params);
        thunkAPI.dispatch(getInsightsReports(getReportsParams));
    }
);

export const deleteInsightsReportById = createAsyncThunk(
    'insightsReports/deleteInsightsReportById',
    async (id) => fetchRequest(`/insights/reports/${id}`, 'DELETE')
);

export const updateInsightsReportTextById = createAsyncThunk(
    'insightsReports/updateInsightsReportTextById',
    async ({
        reportId, textId, statusId, textOverwrite
    }) => fetchRequest(`/insights/reports/${reportId}/${textId}`, 'PATCH', null, omitEmpty({statusId, textOverwrite}))
);

export const downloadInsightsReport = async (reportId) => fetchDownloadRequest(`/insights/reports/${reportId}/download`);
